import script from "./SimpleKeyboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleKeyboard.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleKeyboard.vue?vue&type=style&index=0&id=aab48dc6&lang=scss"

const __exports__ = script;

export default __exports__